import { useEffect, useRef } from 'react';
import classnames from 'classnames';
import { any, bool, func, object, string } from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import LoadingWrapper from '~/components/LoadingWrapper';

import { POPUP_OVERLAY_ID } from '~/config';

import styles from './PopupAbstract.module.scss';

let modals = [];

const PopupAbstract = ({
  children,
  className,
  onClose,
  loading,
  skipBlur,
  style,
  wrapperClassName,
  contentElementId,
}) => {
  const idRef = useRef(uuidv4());

  useEffect(() => {
    function handelEscapeButton(e) {
      if (
        e.key === 'Escape' &&
        modals[modals.length - 1] === idRef.current &&
        onClose
      ) {
        onClose();
      }
    }

    document.addEventListener('keydown', handelEscapeButton);
    return () => {
      document.removeEventListener('keydown', handelEscapeButton);
    };
  }, [onClose]);

  useEffect(() => {
    const { current: id } = idRef;
    modals.push(id);

    const { body } = document;
    if (!skipBlur) {
      body.classList.add('modal-opened');
    }
    body.style.paddingRight = `${window.innerWidth - body.clientWidth}px`;
    body.style.overflow = 'hidden';

    return () => {
      if (document.getElementsByClassName(styles.popupContainer).length === 0) {
        modals = [];
      } else {
        modals = modals.filter((modalId) => modalId !== id);
      }

      if (modals.length === 0) {
        body.classList.remove('modal-opened');
        body.style.overflow = 'auto';
        body.style.paddingRight = 0;
      }
    };
  }, [skipBlur]);

  return (
    <div
      className={classnames(wrapperClassName, styles.popupContainer)}
      id={POPUP_OVERLAY_ID}
    >
      <div className={styles.overlayWrapper}>
        <div
          className={styles.overlay}
          onClick={onClose}
        />
        <div
          className={classnames(className, styles.popupContent)}
          style={style}
          id={contentElementId ?? undefined}
        >
          <LoadingWrapper loading={Boolean(loading)}>{children}</LoadingWrapper>
        </div>
      </div>
    </div>
  );
};

export const propTypes = {
  children: any.isRequired,
  className: string,
  loading: bool,
  skipBlur: bool,
  style: object,
  wrapperClassName: string,
  contentElementId: string,
};

PopupAbstract.propTypes = {
  ...propTypes,
  onClose: func.isRequired,
};

export default PopupAbstract;
